module.exports = __webpack_public_path__ + "img/icon-card-guide.04a3555a.svg";